import {getQueryArg} from "./src/helpers"
import {Map} from "./src/Map"

import "./iframe.css"

// @ts-ignore
const baseurl = document.currentScript.src.replace(/\/embed\/iframe\.(v[^.]+)?\.js(\?.*|)$/, '')
// @ts-ignore
const query = getQueryArg('apikey', false, document.currentScript.src)
// @ts-ignore
let style = getQueryArg('style', 'osm-bright-gl')
if (!['osm-bright-gl', 'osm-liberty-gl'].includes(style)) {
    style = 'osm-bright-gl'
}

Map({
    container: 'map',
    style: baseurl + '/styles/' + style + '/style.json' + (query ? '?apikey=' + query : ''),
    center: [parseFloat(getQueryArg('lng', 9.080724)), parseFloat(getQueryArg('lat', 54.492146))],
    zoom: parseFloat(getQueryArg('zoom', 16)),
}, {
    markerColor: getQueryArg('color'),
    showInfobox: true,
    infoboxOptions: {
        title: getQueryArg('title'),
        strasse: getQueryArg('strasse'),
        plz: getQueryArg('plz'),
        stadt: getQueryArg('stadt'),
    },
    cooperativeGestures: !getQueryArg('force-disable-cooperative-gestures', false),
    disableScrollZoom: !getQueryArg('force-allow-scroll-zoom', false)
})
